export default {
    'en-US': {
        // title/content/description
        activeNotes: 'Active Notes',
        archivedNotes: 'Archived Notes',
        noNotes: 'No notes',
        notFound: 'Not found',

        // button/link
        login: 'Login',
        logout: 'Logout',
        register: 'Register',
        unarchive: 'Unarchive',
        archive: 'Archive',
        delete: 'Delete',
        back: 'Back',
        saveNote: 'Save note',
        backToHome: 'Back to home',
        addNewNote: 'Add new note',
        registerHere: 'Register here',
        loginHere: 'Login here',

        // form/input
        searchNote: 'Search note...',
        noteTitle: 'Note title',
        writeYourNote: 'Write your note',
        remainingCharacters: 'Remaining characters',
        cannotEmpty: 'Note contents cannot be empty!',
        loginToYourAccount: 'Login to your account',
        dontHaveAccount: `Don't have an account? `,
        haveAccount: 'Already have an account? ',
        createAccount: 'Create new account',
        name: 'Name',
    },
    'id-ID': {
        // title/content/description
        activeNotes: 'Catatan Aktif',
        archivedNotes: 'Catatan Terarsip',
        noNotes: 'Tidak ada catatan',
        notFound: 'Tidak ditemukan',

        // button/link
        login: 'Masuk',
        logout: 'Keluar',
        register: 'Daftar',
        unarchive: 'Batalkan Arsip',
        archive: 'Arsipkan',
        delete: 'Hapus',
        back: 'Kembali',
        saveNote: 'Simpan catatan',
        backToHome: 'Kembali ke beranda',
        addNewNote: 'Tambah catatan baru',
        registerHere: 'Daftar di sini',
        loginHere: 'Masuk di sini',

        // form/input
        searchNote: 'Cari catatan...',
        noteTitle: 'Judul catatan',
        writeYourNote: 'Tulis catatan anda',
        remainingCharacters: 'Karakter tersisa',
        cannotEmpty: 'Isi catatan tidak boleh kosong!',
        loginToYourAccount: 'Masuk ke akun Anda',
        dontHaveAccount: `Tidak punya akun? `,
        haveAccount: 'Sudah punya akun? ',
        createAccount: 'Buat akun baru',
        name: 'Nama',
    },
};
